import { jsx as e, jsxs as a, Fragment as w } from "react/jsx-runtime";
import { MoreVertical as E } from "lucide-react";
import { forwardRef as C, useId as R, useMemo as _ } from "react";
import { A } from "./Avatar-ihLwDM5D.js";
import { C as m } from "./Card-BpiP0p3P.js";
import { C as P } from "./ColorDot-DYvEaW9c.js";
import { I } from "./IconButton-D1bLZM6I.js";
import { S as O } from "./SourcePill-CgQffD-I.js";
import { C as z } from "./CampaignStatusPill-BgJs607o.js";
import { P as D } from "./ProgressBar-CTZZKLVV.js";
import { S as n } from "./Skeleton-BOboktJd.js";
import { S as l } from "./Stat-DaYLkgFc.js";
import { c as f } from "./cn-DlLpp5ix.js";
const N = {
  draft: "accent",
  active: "success",
  paused: "warning",
  paused_auto: "accent",
  finished: "accent",
  error: "warning"
};
function o(s, t) {
  if (t <= 0) return 0;
  const r = s / t * 100;
  return Number.isFinite(r) ? Math.max(0, Math.min(100, Math.round(r))) : 0;
}
function Y(s) {
  return typeof s != "string" ? "" : s.trim().split(/\s+/).slice(0, 2).map((r) => r[0] ?? "").join("").toUpperCase();
}
const k = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-3)",
  width: "100%"
}, M = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--space-3)",
  width: "100%"
}, W = {
  display: "flex",
  alignItems: "center",
  gap: "var(--space-2)",
  flexWrap: "wrap"
}, F = {
  fontFamily: "var(--font-sans)",
  fontSize: "var(--text-md)",
  fontWeight: 700,
  color: "var(--text-primary)",
  lineHeight: "var(--line-md)",
  margin: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, H = {
  fontSize: "var(--text-xs)",
  color: "var(--text-tertiary)",
  fontStyle: "italic"
}, U = {
  display: "flex",
  alignItems: "center",
  gap: "var(--space-2)",
  fontSize: "var(--text-xs)",
  color: "var(--text-secondary)",
  flexWrap: "wrap"
}, p = {
  color: "var(--text-tertiary)"
}, j = {
  display: "grid",
  gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
  gap: "var(--space-3)"
}, B = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "var(--text-xs)",
  color: "var(--text-tertiary)",
  marginTop: "var(--space-1)"
}, G = {
  fontSize: "var(--text-sm)",
  color: "var(--text-tertiary)",
  fontStyle: "italic",
  margin: 0
}, $ = C(function({ campaign: t, copy: r, onOpen: h, onKebab: v, className: g }, S) {
  const x = R(), y = N[t.status], c = Y(t.account), i = _(
    () => ({
      acceptedPct: o(t.metrics.accepted, t.metrics.invited),
      repliedPct: o(t.metrics.replied, t.metrics.accepted),
      progressPct: o(t.metrics.invited, t.metrics.leads)
    }),
    [t.metrics]
  ), b = t.status === "draft", d = t.status === "paused_auto" ? t.pauseReason : t.status === "error" ? t.errorReason : null, u = r.rowAriaLabel?.(t.name) ?? (typeof t.name == "string" ? t.name : void 0), L = r.progressAriaLabel?.(i.progressPct);
  return /* @__PURE__ */ e(m, { ref: S, asChild: !0, padding: "lg", radius: "2xl", className: f("ls-campaign-row", g), children: /* @__PURE__ */ e(
    "article",
    {
      "aria-label": u,
      "data-ls-composite": "campaign-row",
      "data-id": t.id,
      "data-status": t.status,
      children: /* @__PURE__ */ a("div", { style: k, children: [
        /* @__PURE__ */ a("div", { style: M, children: [
          /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              "data-ls-campaign-open": !0,
              "aria-label": u,
              onClick: () => h(t.id),
              style: {
                all: "unset",
                cursor: "pointer",
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: "var(--space-2)"
              },
              children: [
                /* @__PURE__ */ a("div", { style: W, children: [
                  /* @__PURE__ */ e("h3", { id: x, style: F, "data-ls-campaign-name": !0, children: t.name }),
                  /* @__PURE__ */ e(z, { status: t.status, size: "sm", children: r.statusLabel[t.status] }),
                  d ? /* @__PURE__ */ a("span", { style: H, "data-ls-campaign-hint": !0, children: [
                    "· ",
                    d
                  ] }) : null
                ] }),
                /* @__PURE__ */ a("div", { style: U, "data-ls-campaign-subrow": !0, children: [
                  /* @__PURE__ */ e(
                    A,
                    {
                      size: "xs",
                      tone: "identity",
                      identityColor: t.accountColor,
                      initials: c,
                      alt: typeof t.account == "string" ? t.account : c || ""
                    }
                  ),
                  /* @__PURE__ */ e(
                    P,
                    {
                      size: "sm",
                      color: t.accountColor,
                      "aria-hidden": "true",
                      style: { display: "none" }
                    }
                  ),
                  /* @__PURE__ */ e("span", { "data-ls-campaign-account": !0, children: t.account }),
                  /* @__PURE__ */ e("span", { "aria-hidden": "true", style: p, children: "·" }),
                  /* @__PURE__ */ e("span", { "data-ls-campaign-business": !0, children: t.business }),
                  /* @__PURE__ */ e("span", { "aria-hidden": "true", style: p, children: "·" }),
                  /* @__PURE__ */ e(O, { source: t.source, size: "sm", children: t.sourceLabel })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ e(
            I,
            {
              variant: "ghost",
              size: "sm",
              icon: /* @__PURE__ */ e(E, { "aria-hidden": "true", size: 14 }),
              "aria-label": r.kebabLabel,
              "data-ls-campaign-kebab": !0,
              onClick: (T) => {
                T.stopPropagation(), v(t.id);
              }
            }
          )
        ] }),
        b ? /* @__PURE__ */ e("p", { style: G, "data-ls-campaign-draft-hint": !0, children: r.draftHint }) : /* @__PURE__ */ a(w, { children: [
          /* @__PURE__ */ a("div", { style: j, "data-ls-campaign-stats": !0, children: [
            /* @__PURE__ */ e(
              l,
              {
                align: "start",
                value: t.metrics.leads.toLocaleString(),
                label: r.stats.leads
              }
            ),
            /* @__PURE__ */ e(
              l,
              {
                align: "start",
                value: t.metrics.invited.toLocaleString(),
                label: r.stats.invited
              }
            ),
            /* @__PURE__ */ e(
              l,
              {
                align: "start",
                value: t.metrics.accepted.toLocaleString(),
                label: r.stats.accepted,
                sublabel: `${i.acceptedPct}%`
              }
            ),
            /* @__PURE__ */ e(
              l,
              {
                align: "start",
                value: t.metrics.replied.toLocaleString(),
                label: r.stats.replied,
                sublabel: `${i.repliedPct}%`
              }
            ),
            /* @__PURE__ */ e(
              l,
              {
                align: "start",
                tone: t.metrics.hot > 0 ? "error" : "neutral",
                value: t.metrics.hot.toLocaleString(),
                label: r.stats.hot
              }
            )
          ] }),
          /* @__PURE__ */ a("div", { "data-ls-campaign-progress": !0, children: [
            /* @__PURE__ */ e(
              D,
              {
                size: "xs",
                tone: y,
                value: i.progressPct,
                "aria-label": L
              }
            ),
            /* @__PURE__ */ e("div", { style: B, children: /* @__PURE__ */ e("span", { "data-ls-campaign-progress-desc": !0, children: r.progressDescription({
              pct: i.progressPct,
              daysRunning: t.daysRunning,
              dailyLimit: t.dailyLimit
            }) }) })
          ] })
        ] })
      ] })
    }
  ) });
});
$.displayName = "CampaignRow";
const K = "Loading campaign";
function nt({
  className: s,
  "aria-label": t = K
}) {
  return /* @__PURE__ */ e(m, { padding: "lg", radius: "2xl", className: f("ls-campaign-row-skeleton", s), children: /* @__PURE__ */ a(
    "div",
    {
      role: "status",
      "aria-label": t,
      "aria-busy": "true",
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-3)"
      },
      children: [
        /* @__PURE__ */ a("div", { style: { display: "flex", alignItems: "center", gap: "var(--space-2)" }, children: [
          /* @__PURE__ */ e(n, { variant: "text", width: "40%", height: 16 }),
          /* @__PURE__ */ e(n, { variant: "rect", width: 60, height: 20 })
        ] }),
        /* @__PURE__ */ e(
          "div",
          {
            style: { display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "var(--space-3)" },
            children: [0, 1, 2, 3, 4].map((r) => /* @__PURE__ */ e(n, { variant: "rect", height: 48 }, r))
          }
        ),
        /* @__PURE__ */ e(n, { variant: "rect", height: 6 })
      ]
    }
  ) });
}
export {
  $ as C,
  nt as a
};
//# sourceMappingURL=CampaignRow-vDQop6OS.js.map
